<template>
  <div
    class="question-container"
    @touchmove.stop
    @touchstart.stop
    @touchend.stop
  >
    <div class="question">
      <img
        class="banner"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/50847aee4f33af8f04a8465cc66858f6_wh=1340_440.webp"
        alt=""
      />
      <div class="q-list">
        <div class="q-item">
          <div class="q-title"
            ><span class="q-title-index">01.</span
            ><span>怎么称呼您呢？</span></div
          >
          <div class="a-list">
            <div class="input-container">
              <input
                type="text"
                v-model="questionData.username"
                placeholder="请输入称呼"
                maxlength="20"
              />
            </div>
          </div>
        </div>
        <div class="q-item">
          <div class="q-title"
            ><span class="q-title-index">02.</span
            ><span>坚持健身多久啦？</span></div
          >
          <div class="a-list">
            <div
              class="a-item"
              :class="{
                'a-item-active': questionData.continue_time == item.key
              }"
              v-for="(item, index) in questionOptions.continue_time"
              :key="index"
              @click="bindChangeFitnessTime(item)"
            >
              {{ item.label }}</div
            >
          </div>
        </div>
        <div class="q-item">
          <div class="q-title"
            ><span class="q-title-index">03.</span
            ><span>目前想达成的健身目标是？</span
            ><span class="check-box">（可多选）</span></div
          >
          <div class="a-list">
            <div
              class="a-item"
              :class="{
                'a-item-active': questionData.current_target.includes(item.key)
              }"
              v-for="(item, index) in questionOptions.current_target"
              :key="index"
              @click="bindChangeTarget(item)"
              >{{ item.label }}</div
            >
          </div>
        </div>
        <div class="q-item">
          <div class="q-title"
            ><span class="q-title-index">04.</span
            ><span>您的理想训练时段是？</span></div
          >
          <div class="a-list">
            <div
              class="a-item"
              :class="{
                'a-item-active': questionData.hope_fitness_period == item.key
              }"
              v-for="(item, index) in questionOptions.hope_fitness_period"
              :key="index"
              @click="bindChangeTimePeriod(item)"
              >{{ item.label }}</div
            >
          </div>
        </div>
        <div class="q-item">
          <div class="q-title"
            ><span class="q-title-index">05.</span
            ><span>您理想的每周运动频率是？</span></div
          >
          <div class="a-list">
            <div
              class="a-item"
              :class="{ 'a-item-active': questionData.weeklyTime == item.key }"
              v-for="(item, index) in questionOptions.weeklyTime"
              :key="index"
              @click="bindChangeWeeklyTime(item)"
              >{{ item.label }}</div
            >
          </div>
        </div>

        <div class="s-btn" @click="bindSubmit">提交</div>
      </div>
    </div>
    <img
      class="logo"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/18fca4a72b27a928fa6d758219df4b2a_wh=876_112.webp"
      alt=""
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      questionData: {
        username: '',
        continue_time: '',
        current_target: [],
        hope_fitness_period: '',
        weeklyTime: ''
      },
      questionOptions: {
        continue_time: [
          {
            key: '0-1年',
            label: '0-1年'
          },
          {
            key: '1-3年',
            label: '1-3年'
          },
          {
            key: '3年以上',
            label: '3年以上'
          }
        ],
        current_target: [
          {
            key: '体态调整',
            label: '体态调整'
          },
          {
            key: '减脂塑形',
            label: '减脂塑形'
          },
          {
            key: '增肌塑形',
            label: '增肌塑形'
          },
          {
            key: '拉伸放松',
            label: '拉伸放松'
          }
        ],
        hope_fitness_period: [
          {
            key: '9:00-12:00',
            label: '9:00-12:00'
          },
          {
            key: '12:00-18:00',
            label: '12:00-18:00'
          },
          {
            key: '18:00-21:00',
            label: '18:00-21:00'
          }
        ],
        weeklyTime: [
          {
            key: '每周1次',
            label: '每周1次'
          },
          {
            key: '每周2-3次',
            label: '每周2-3次'
          },
          {
            key: '每周4-5次',
            label: '每周4-5次'
          }
        ]
      }
    }
  },
  created() {},
  methods: {
    bindChangeFitnessTime(item) {
      this.questionData.continue_time = item.key
    },
    bindChangeTarget(item) {
      let list = [...this.questionData.current_target]
      let isCheck = list.includes(item.key)
      if (isCheck) {
        list = list.filter((item1) => {
          return item1 !== item.key
        })
      } else {
        list.push(item.key)
      }
      this.questionData.current_target = list
    },
    bindChangeTimePeriod(item) {
      this.questionData.hope_fitness_period = item.key
    },
    bindChangeWeeklyTime(item) {
      this.questionData.weeklyTime = item.key
    },
    checkQuestion() {
      if (!this.questionData.username) {
        this.$toast('请填写称呼')
        return
      }
      if (!this.questionData.continue_time) {
        this.$toast('请选择健身时间')
        return
      }
      if (!this.questionData.current_target.length) {
        this.$toast('请选择健身目标')
        return
      }
      if (!this.questionData.hope_fitness_period) {
        this.$toast('请选择训练时段')
        return
      }
      if (!this.questionData.weeklyTime) {
        this.$toast('请选择每周运动频率')
        return
      }
      return true
    },
    arraysEqual(arr1, arr2) {
      const set1 = new Set(arr1)
      const set2 = new Set(arr2)
      return set1.size === set2.size && [...set1].every((v) => set2.has(v))
    },
    //比较表单数据是否一致
    compareData() {
      for (let key in this.questionData) {
        if (Array.isArray(this.questionData[key])) {
          if (!this.arraysEqual(this.questionData[key], this.beforeData[key])) {
            return false
          }
        } else {
          if (this.questionData[key] != this.beforeData[key]) {
            return false
          }
        }
      }
      return true
    },
    async bindSubmit() {
      if (this.isSubmit && this.compareData()) {
        this.$emit('submit')
        return
      }
      if (!this.checkQuestion()) {
        return
      }
      let params = Object.assign(
        { extra: { weeklyTime: this.questionData.weeklyTime } },
        this.questionData
      )
      delete params.weeklyTime
      let res = await this.$http.postApp(
        'api/v1/QuestionnaireFitness/add',
        params
      )
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('提交成功')
          this.$emit('submit')
          this.isSubmit = true
          this.beforeData = Object.assign({}, this.questionData)
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.question-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.question {
  position: relative;
  width: 335px;
  margin: 61px auto 0px;
  background: #ffffff;
  box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  backdrop-filter: blur(10px);
  padding-top: 101px;

  .banner {
    position: absolute;
    width: 100%;
    left: 0;
    top: -9px;
  }

  .q-list {
    padding: 20px 20px 26px;

    .q-item {
      margin-bottom: 30px;

      .q-title {
        text-align: left;
        font-weight: normal;
        font-size: 16px;
        color: #050b27;
        line-height: 22px;
        margin-bottom: 10px;

        .check-box {
          color: rgba(172, 174, 183, 1);
        }

        .q-title-index {
          font-weight: bold;
          font-size: 16px;
          color: rgba(5, 11, 39, 0.3);
          line-height: 22px;
          margin-right: 6px;
        }
      }

      .a-list {
        padding-left: 30px;
        display: flex;
        flex-wrap: wrap;

        .a-item {
          position: relative;
          width: 130px;
          height: 36px;
          background: #f1f1f1;
          border-radius: 2px;
          font-size: 14px;
          color: #050b27;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 5px;
          margin-bottom: 5px;
        }

        .a-item:nth-child(2n) {
          margin-right: 0px;
        }

        .a-item-active {
          background: #050b27;
          color: #ffffff;
        }

        .a-item-active::after {
          content: '';
          position: absolute;
          width: 12px;
          height: 10px;
          right: 10px;
          top: 50%;
          transform: translate(0%, -50%);
          background-repeat: no-repeat;
          background-size: 100%;
          background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/1f6be4a5df6e313d3050e4dda20115ae_wh=48_40.webp');
        }
      }

      .input-container {
        width: 100%;
        border-bottom: 1px solid #000000;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        input {
          font-size: 14px;
          width: 100%;
          color: rgba(5, 11, 39, 1);
          height: 32px;
          padding: 0px 0px 8px;
          box-sizing: border-box;
          border: none;
          outline: none;
          background-color: transparent;
        }

        input::placeholder {
          font-size: 14px;
          color: rgba(5, 11, 39, 0.3);
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .tips {
    text-align: center;
    color: rgba(5, 11, 39, 0.5);
    font-size: 10px;
    line-height: 14px;
    margin-bottom: 10px;
  }

  .s-btn {
    height: 40px;
    background: #ff0647;
    border-radius: 22px;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.logo {
  width: 219px;
  height: 28px;
  margin: 20px auto;
}
</style>
